import { Col, DatePicker, Form, Input, InputNumber, Row, Select } from 'antd'
import CustomSpin from '../../../elements/CustomSpin'
import DeliveryDetails from '../../../elements/DeliveryDetails'
import FormSectionTitle from '../../../elements/FormSectionTitle'
import withSort from '../../../elements/HOC/withSort'
import withSpinning from '../../../elements/HOC/withSpinning'
import useFetchSelectUrl from '../../../elements/Hooks/useFetchSelectUrl'
import MultiCurrency from '../../../elements/MultiCurrency'
import CountrySelect from '../../../elements/Select/Country'
import CustomSelect from '../../../elements/Select/CustomSelect'
import OrganisationsSelect from '../../../elements/Select/Organistaions'
import withData from '../../../elements/Select/withData'
import withUrlFetch from '../../../elements/Select/withUrlFetch'
import { get, isEmpty } from 'lodash'
import { defaultFormItemLayout, fullWidthFormItemLayout, rules, threeFormItemLayout } from '../../../modules/FormItems'
import { dateVal } from '../../../modules/Utils'
import moment from 'moment'
import React, { Fragment } from 'react'

import { compose } from 'recompose'
import IconText from '../../../elements/IconText'
import withSelectFetch from '../../../elements/Select/withSelectFetch'
import Taxes from '../../../elements/Taxes'

const { TextArea } = Input

function StockReleaseOrderForm(props) {
  const { order, selectionData, VendorQuote, VendorQuoteLine, fetchingOrders, fetching, isNew } = props

  const { getFieldDecorator, getFieldValue, setFieldsValue, resetFields } = props.form

  const max = selectionData && selectionData.reduce((sum, x) => x.max + sum, 0)
  const type = get(order, 'orderType') || get(selectionData, '[0].type')
  const isService = type === 'Service'

  const isCollection = getFieldValue('isCollection')
  const typeValue = getFieldValue('valueType')

  const collectionCountry = getFieldValue('collection.address.country') || get(order, 'collection.address.country', '')

  const CollectionLocationSelect = compose(
    withUrlFetch({
      name: 'collectionLocation',
      url: `location/${collectionCountry}`,
      cache: false,
    }),
    withSpinning
  )(CustomSelect)

  const [showDesc, setShowDesc] = React.useState(() => !isEmpty(order.description))

  const company = getFieldValue('company._id') || ''
  const [CompanyRepSelect] = useFetchSelectUrl(
    {
      name: 'companyRep',
      url: `members/${company.replace('members/', '')}/representatives`,
    },
    [company],
    isEmpty(company)
  )

  const vendor = getFieldValue('vendor._id') || ''
  const [ClientRepSelect] = useFetchSelectUrl(
    {
      name: 'vendorRep',
      url: `members/${vendor.replace('members/', '')}/representatives`,
    },
    [vendor],
    isEmpty(vendor)
  )

  const [PurchaseContractsSelect] = useFetchSelectUrl(
    {
      name: 'vendor_contracts',
      url: `/purchaseContracts?select=*&status=Approved&owner=${vendor}&company=${company}&state=active`,
    },
    [vendor, company],
    isEmpty(vendor) && isEmpty(company),
    Select,
    (c) => ({ ...c, display: `[${c.code}]  ${c.title} - ${c.company.fn}` })
  )

  return (
    <CustomSpin spinning={fetchingOrders || fetching}>
      <Form>
        <Row>
          <Row>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Company">
                {getFieldDecorator('company._id', {
                  initialValue: get(order, 'company._id'),
                  rules: rules.select,
                })(<OrganisationsSelect />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              {company && (
                <Form.Item {...defaultFormItemLayout} label="Company Rep">
                  {getFieldDecorator('companyRep._id', {
                    initialValue: get(order, 'companyRep._id'),
                    rules: rules.select,
                  })(
                    <CompanyRepSelect
                      placeholder="Received By"
                      keyAtr={'_id'}
                      valueAtr={'name'}
                      style={{ width: '100%' }}
                    />
                  )}
                </Form.Item>
              )}
            </Col>
          </Row>

          <Row>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Stock Holder">
                {getFieldDecorator('vendor._id', {
                  initialValue: get(order, 'vendor._id'),
                  rules: rules.select,
                })(<OrganisationsSelect />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              {vendor && (
                <Form.Item {...defaultFormItemLayout} label="Stock Holder Rep">
                  {getFieldDecorator('vendorRep._id', {
                    initialValue: get(order, 'vendorRep._id'),
                    rules: rules.select,
                  })(
                    <ClientRepSelect
                      placeholder="Received By"
                      keyAtr={'_id'}
                      valueAtr={'name'}
                      style={{ width: '100%' }}
                    />
                  )}
                </Form.Item>
              )}
            </Col>
          </Row>

          {!isEmpty(vendor) && !isEmpty(company) && vendor !== company && (
            <Row>
              <Col span={12}>
                <Form.Item {...defaultFormItemLayout} label="Select an Contract">
                  {getFieldDecorator('contract._id', {
                    initialValue: get(order, 'contract._id'),
                    rules: rules.select,
                  })(<PurchaseContractsSelect keyAtr={'_id'} valueAtr={'display'} placeholder={'Account'} />)}
                </Form.Item>
              </Col>
            </Row>
          )}

          <FormSectionTitle title={'Stock Release Order'} />

          <Row>
            <Col span={6}>
              <Form.Item {...threeFormItemLayout} label={'Order For'}>
                {getFieldDecorator('orderType', {
                  initialValue: get(order, 'orderType') || get(selectionData, '[0]category'),
                  rules: rules.select,
                })(<RequisitionsTypeSelect />)}
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item {...threeFormItemLayout} label={'Order Date'}>
                {getFieldDecorator('date', {
                  initialValue: dateVal(order, 'date') || moment(),
                  rules: [{ required: true, message: 'Please Select a Order Date!' }],
                })(<DatePicker style={{ width: '100%' }} />)}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item {...fullWidthFormItemLayout} label={'Title '}>
                {getFieldDecorator('title', {
                  initialValue: get(order, 'title') || get(VendorQuote, 'title'),
                  rules: [{ required: true, message: 'Please Select a Title!' }],
                })(<Input placeholder={'Title'} />)}
                <IconText
                  text={
                    showDesc !== true ? 'Optionally Add Order Summary Description' : 'Remove Order Summary Description'
                  }
                  type={showDesc !== true ? 'plus-circle' : 'minus-circle'}
                  onClick={() => setShowDesc(!showDesc)}
                />
              </Form.Item>
            </Col>
          </Row>
          {showDesc === true && (
            <Row>
              <Col span={24}>
                <Form.Item {...fullWidthFormItemLayout} label={'Summary'}>
                  {getFieldDecorator('description', {
                    initialValue: get(order, 'description'),
                    rules: rules.input,
                  })(<TextArea placeholder={'Order Summary'} />)}
                </Form.Item>
              </Col>
            </Row>
          )}
          {isService && (
            <Row>
              <Col span={24}>
                <Form.Item {...fullWidthFormItemLayout} label="Scope of Work">
                  {getFieldDecorator('scope', {
                    initialValue: get(order, 'scope'),
                    rules: rules.input,
                  })(<TextArea rows={7} />)}
                </Form.Item>
              </Col>
            </Row>
          )}
          <Row>
            <MultiCurrency
              doc={{
                ...order,
                currency: get(order, 'currency') || get(VendorQuote, 'currency'),
              }}
              {...{
                getFieldDecorator,
                getFieldValue,
                setFieldsValue,
                type: 'purchase',
              }}
            />
            <Col span={8}>
              <Form.Item {...threeFormItemLayout} label="Value Type">
                {getFieldDecorator('valueType', {
                  initialValue: get(order, 'valueType') || 'Fixed & Firm',
                })(<TypeValue style={{ width: '80%' }} />)}
              </Form.Item>
            </Col>
            {typeValue !== 'fixed&firm' && typeValue && (
              <Col span={8}>
                <Form.Item {...threeFormItemLayout} label="Maximum Amount">
                  {getFieldDecorator('max', {
                    initialValue: get(order, 'max') || max,
                    rules: rules.select,
                  })(<InputNumber style={{ width: '80%' }} />)}
                </Form.Item>
              </Col>
            )}
            <Taxes
              doc={order}
              {...{
                getFieldDecorator,
                getFieldValue,
                setFieldsValue,
                resetFields,
                type: 'Purchase',
                //price: lines ? sum(lines.map(d => numVal(d, 'amount.net'))) : 0,
                hideRate: true,
              }}
            />
          </Row>

          <Row style={{ paddingBottom: '10px', paddingTop: '10px' }}>
            <h3 style={{ color: 'rgb(43,187,143' }}>TERMS & CONDITIONS</h3>
          </Row>

          <Row>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Order Validity Start">
                {getFieldDecorator('validityStart', {
                  initialValue: dateVal(order, 'validityStart') || moment(),
                  rules: rules.date,
                })(
                  <DatePicker
                    style={{ width: '100%' }}
                    onChange={(e) => setFieldsValue({ validityEnd: moment(e).add(1, 'M') })}
                  />
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Order Validity End">
                {getFieldDecorator('validityEnd', {
                  initialValue: dateVal(order, 'validityEnd') || moment().add(1, 'M'),
                  rules: rules.date,
                })(<DatePicker style={{ width: '100%' }} />)}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item {...fullWidthFormItemLayout} label="Payment Terms">
                {getFieldDecorator('paymentTerm', {
                  initialValue: get(order, 'paymentTerm') || 'Account',
                  rules: rules.select,
                })(<PaymentTermValue />)}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item {...fullWidthFormItemLayout} label="Special Conditions">
                {getFieldDecorator('condition', {
                  initialValue: get(order, 'condition'),
                })(<TextArea rows={7} />)}
              </Form.Item>
            </Col>
          </Row>
          <DeliveryDetails
            doc={order}
            {...{
              getFieldDecorator,
              getFieldValue,
              setFieldsValue,
              resetFields,
              type: 'Purchase',
              title: 'Stock Holder',
            }}
          />
          {isCollection && (
            <Fragment>
              <Row style={{ paddingBottom: '10px', paddingTop: '10px' }}>
                <h3 style={{ color: 'rgb(43,187,143' }}>COLLECTION DETAILS</h3>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item {...fullWidthFormItemLayout} label="Address Label">
                    {getFieldDecorator('collection.address.label', {
                      initialValue: get(order, 'collection.address.label'),
                      rules: rules.input,
                    })(<Input placeholde={'label'} />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label="Email">
                    {getFieldDecorator('collection.address.email', {
                      initialValue: get(order, 'collection.address.email'),
                      rules: rules.input,
                    })(<Input placeholde={'Notify Email'} />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label="Notify">
                    {getFieldDecorator('collection.address.notify', {
                      initialValue: get(order, 'collection.address.notify'),
                      rules: rules.input,
                    })(<Input placeholde={'Notify Name'} />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label="Tel">
                    {getFieldDecorator('collection.address.tel', {
                      initialValue: get(order, 'collection.address.tel'),
                    })(<Input placeholde={'Notify Tel'} />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label="Country">
                    {getFieldDecorator('collection.address.country', {
                      initialValue: get(order, 'collection.address.country'),
                      rules: rules.select,
                    })(<CountrySelect />)}
                  </Form.Item>
                </Col>
                {collectionCountry && (
                  <Col span={12}>
                    <Form.Item {...defaultFormItemLayout} label="Location">
                      {getFieldDecorator('collection.address.location', {
                        initialValue: get(order, 'collection.address.location'),
                        rules: rules.select,
                      })(<CollectionLocationSelect keyAtr={'locode'} valueAtr={'location'} />)}
                    </Form.Item>
                  </Col>
                )}
              </Row>
            </Fragment>
          )}
        </Row>
      </Form>
    </CustomSpin>
  )
}

const RequisitionsTypeSelect = compose(
  withSelectFetch({
    dropdown: 'requisitions',
    name: 'type',
  }),
  withSpinning,
  withSort
)(CustomSelect)

const PaymentTermValue = compose(
  withData({
    data: [
      { value: 'Account', key: 'Account' },
      { value: 'Prepaid', key: 'Prepaid' },
      { value: 'On Delivery', key: 'On Delivery' },
      { value: 'Deposit and On Delivery', key: 'Deposit and On Delivery' },
      { value: 'Milestone', key: 'Milestone' },
    ],
  }),
  withSort
)(CustomSelect)

const TypeValue = compose(
  withData({
    data: [
      { value: 'Fixed & Firm', key: 'fixed&firm' },
      { value: 'Estimated', key: 'estimated' },
      { value: 'Scheduled Rates', key: 'scheduledRates' },
    ],
  }),
  withSort
)(CustomSelect)

export default Form.create()(StockReleaseOrderForm)
